export enum SaleFamilyCategoryRoutingEnum {
  ancien = 'Patrimoine ancien',
  neuf = 'Patrimoine neuf'
}
